export { default } from '../spinner';
